module.exports = __webpack_public_path__ + "static/media/galeryAntihumidity15.c8aa834c.jpg";